import { Link } from 'react-router-dom';
import './nav-logo.less';

interface Props {
  className?: string
  invisible?: boolean
  isLink: boolean
}

export default function NavLogo(props: Props) {
  if (!!props.invisible) {
    return null
  }

  let className = "nav-logo"
  if (props.className) {
    className += " " + props.className;
  }

  if (props.isLink) {
    return <Link to="/" className={className}>
    </Link>
  } else {
  return <div className={className}>
    </div>
  }
}